import styled from 'styled-components';
import StyledLink from '@components/common/Link';

export const HeroLink = styled(StyledLink)`
  margin-bottom: 24px;
`;

export const Wrapper = styled.div`
  padding-top: 105px;
  margin-bottom: 95px;
  display: flex;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding-top: 60px;
    margin-bottom: 60px;
  }
`;

export const Content = styled.div`
  width: 455px;
  h1 {
    padding-bottom: 8px;
  }
  h4 {
    font-weight: 400;
    font-family: ${({ theme }) => theme.fonts.archivo};
    padding-bottom: 58px;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    h3 {
      padding-bottom: 32px;
    }
  }
  b {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const HeroImageWrapper = styled.div`
  width: 794px;
  svg {
    aspect-ratio: 2.29;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    position: absolute;
    width: 384px;
    right: 0;
    bottom: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: none;
  }
`;
